export interface KeypadKey {
    readonly digit: string;
    readonly letters?: string;
}

export const KEYPAD_KEYS: readonly KeypadKey[] = [
    {digit: '1'},
    {digit: '2', letters: 'ABC'},
    {digit: '3', letters: 'DEF'},
    {digit: '4', letters: 'GHI'},
    {digit: '5', letters: 'JKL'},
    {digit: '6', letters: 'MNO'},
    {digit: '7', letters: 'PQRS'},
    {digit: '8', letters: 'TUV'},
    {digit: '9', letters: 'WXYZ'},
    {digit: '*'},
    {digit: '0', letters: '+'},
    {digit: '#'},
];
